/* eslint-disable max-lines */
import React, {
  useContext,
  useEffect,
  useState
} from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { googleAds } from "appConfig";

import config from "appConfig";
import styles from "./styles/AdDetailsPage.scss";
import adsStyles from "./styles/Ads.scss";
import utilsStyles from "./../../../styles/utils.scss";
import DetailSection from "./DetailSection";
import SummarySection from "./SummarySection";
import { submitFormData, getModuleContext } from "../../../HOCs";
import {
  PageRoute,
  CurrentPage,
  AdStatus,
  PermutiveEvents,
  HashTag,
  EntityType,
  LocalStorageKey
} from "../../../models/enums";
import { selectLoadedUser, selectUserInfo } from "../../../routes/Auth/auth.ducks";
import {
  selectAdDetails,
  getAdDetails,
  updateViewCount,
  sendEmailToDealerAction,
  getCreatorInfo,
  getAdStatistics
} from "../../../routes/Ad/ad.ducks";
import { selectFavoriteIds } from "../../../routes/Favorite/favorite.ducks";
import {
  selectCategories,
  selectModules
} from "../../App/selectors";
import {
  scrollToElement,
  scrollToTop,
  localStorage,
  isDetailSwitch,
  checkEmptyObject,
  buildBaseUrl,
  PermutiveEventData,
  checkEmptyArray
} from "../../../services";
import history, { navigateToLogin } from "../../../history";
import BreadcrumbBar from "../../../components/BreadcrumbBar";
import TipsSection from "./TipsSection";
import SpecialSection from "./SpecialSection";
import SimilarAdsSection from "./SimilarAdsSection";
import SharingOptions from "../../../components/SharingOptions";
import PrintButton from "../../../components/PrintButton";
import SellerSection from "./SellerSection/SellerSection";
import getWidthContext from "../../../HOCs/getWidthContext";
import HelmetComponent from "../../../utils/HelmetHelper";
import { buildAdDetailStructuredData } from "../../../utils/buildAdDetailStructuredData";
import { useMakes } from "../../../routes/Configuration";
import { CategoryName, CategoryNameHr, ModuleName, ModuleNameHr } from "../../../models";
import { getIconUrl, getImageLink } from "../../../services/asset";
import ReactGA from "react-ga4";
import { Context } from "../../../GAContext";
import { truncate } from "../../../utils/truncateWord";
import { useInView } from "react-intersection-observer";
import { Loading } from "../../../components/Loading";
import ActionBar from "../ActionBar";
import AdDetailsWebLoader from "./AdDetailsWebLoader";
import GoogleAd from "../../../components/GoogleAd";
import useHrPageName from "../../../utils/useHrPageName";
import AgeVerification from "../../../components/AgeVerificationModal";
import { useAgeVerification } from "../../../hooks/useAgeVerification";
import PriceComparison from "../PriceComparison";
import MakeModelInfoCta from "../../../components/MakeModelInfoCta";
import OwnAdBanner from "../OwnAdBanner";
import OwnAdPanel from "../OwnAdPanel";

function AdDetailsPageWeb(props: any) {
  const {
    adDetails,
    loading,
    user,
    userRaw,
    match: {
      params: { id }
    },
    favoriteIds,
    width,
    categories,
    modules
  } = props;

  const [isReportVisible, setIsReportVisible] = useState(false);
  const [GaEvent, setGaEvent] = useContext(Context);
  const [loadingSimilar, setLoadingSimilar] = useState(false);
  const hrPageName = useHrPageName(adDetails && adDetails.category, adDetails && adDetails.module);

  // Use unified age verification hook
  const { ageVerificationModal, shouldShowModal, forbiddAds } = useAgeVerification({
    module: adDetails && adDetails.module,
    category: adDetails && adDetails.category,
    modules,
    categories,
    is18Old: adDetails && adDetails.summary && adDetails.summary.is18Old
  });

  const { ref: similarRef, inView } = useInView({ triggerOnce: true });

  // Makes dataset for JSON-LD `brand` / `model` lookup — only fetched for
  // personal-car ads where the identifier matters for Google rich results.
  // Empty string → useMakes skips the fetch and returns undefined.
  const adModule = adDetails && adDetails.module;
  const adCategory = adDetails && adDetails.category;
  const isCarAd =
    (adModule === ModuleName.vehicles || adModule === ModuleNameHr.vehicles) &&
    (adCategory === CategoryName.car || adCategory === CategoryNameHr.car);
  const makes = useMakes(isCarAd ? CategoryName.car : "");

  useEffect(() => {

    setGaEvent(CurrentPage.details);
    scrollToTop();
    saveVisitedAd();
    return () => {
      setGaEvent("");
    };
  }, []);

  useEffect(() => {
    loadAdDetails(props);
  }, [
    id,
    adDetails !== null,
    favoriteIds,
    userRaw,
  ]);

  useEffect(() => {
    return () => {
      PermutiveEventData.clear(PermutiveEvents.AdPreview, id)
    };
  }, [id]);

  useEffect(() => {
    if (
      adDetails &&
      adDetails.summary &&
      adDetails.summary.id &&
      !loading
    ) {
      props.updateViewCount(adDetails.summary.id);
    }
  }, [checkEmptyObject(adDetails)
    && JSON.stringify(adDetails.summary)
    && adDetails.summary.id
    && !loading]);

  useEffect(() => {
    const adReport = history.location.hash === HashTag.adReport;

    if (adReport) {
      setIsReportVisible(true);
    }

    if (adReport) history.replace(history.location.pathname);
  }, []);

  // Own-ad banner (page position) and panel (phone-click count) both read
  // from the same statistics slice, so we fetch it once at the page level.
  const dispatch = useDispatch();
  const summaryId = adDetails && adDetails.summary && adDetails.summary.id;
  const isOwnAd = Boolean(
    adDetails && adDetails.creator && user && adDetails.creator.id === user.userId
  );
  useEffect(() => {
    if (isOwnAd && summaryId) {
      dispatch(getAdStatistics(summaryId));
    }
  }, [isOwnAd, summaryId]);


  const loadAdDetails = (nextProps: any) => {
    const {
      match: {
        params: { id: adCode }
      },
      favoriteIds,
      module,
      userRaw
    } = nextProps;

    if (favoriteIds && module) {
      props.getAdDetails(
        module,
        adCode,
        props.getCreatorInfo,
        favoriteIds,
        userRaw
      );
    }
  };

  const handleContactClick = () => {
    ReactGA.event({
      category: "Detalji oglasa",
      action: "Click",
      label: `contact button - ${hrPageName}`
    });

    if (user) {
      history.push(`${PageRoute.chats}?adId=${adDetails.summary.id}`)
    } else {
      navigateToLogin(`/oglasi${PageRoute.chats}?adId=${adDetails.summary.id}`);
    }
  };

  const handleEditClick = (adId: any) => {
    const { module } = props;

    history.push(`/${module}${PageRoute.editAd}/${adId}`);
  };

  const handleReportOpen = () => {
    const { user } = props;

    ReactGA.event({
      category: "Detalji oglasa",
      action: "Click",
      label: `Prijavi oglas - ${hrPageName}`
    });

    if (user) {
      setIsReportVisible(true);
    } else {
      navigateToLogin(window.location.href + HashTag.adReport);
    }
  };


  const handleReportClose = () => {
    setIsReportVisible(false);
  };

  const handleReportSubmit = (data: any, onSubmit: any) => {
    const {
      adDetails: {
        summary: { id }
      }
    } = props;

    const reportData = {
      ...data,
      adId: id
    };

    onSubmit(reportData, (status: any) => {
      if (status) {
        handleReportClose();
      }
    });
  };

  const saveVisitedAd = () => {
    const {
      match: {
        params: { id: code }
      }
    } = props;

    let codes = localStorage.getItem(LocalStorageKey.visitedAd) || [];

    if (!codes.includes(code)) {
      codes.unshift(id);
      codes = codes.slice(0, config.localStorageLimits.visitedAd);
      localStorage.setItem(LocalStorageKey.visitedAd, codes);
    }
  };

  const summary = adDetails && adDetails.summary;

  if (!summary || (id !== summary.code.toString() && id !== summary.id)) {
    return <AdDetailsWebLoader />;
    //return <Loading className={`${utilsStyles.PT20} ${utilsStyles.PB20}`} />;
  }

  const showViewedCount = isOwnAd && summary.viewCount !== undefined;

  const hasContact = user ? summary.creatorId !== user.userId : true;

  const refetchAdDetails = () => {
    loadAdDetails(props);
  };

  const ownAdPanel = isOwnAd ? (
    <OwnAdPanel
      adId={adDetails.summary.id}
      adStatus={adDetails.summary.status}
      module={adDetails.module}
      category={adDetails.category}
      viewCount={summary.viewCount || 0}
      favoriteCount={summary.favoriteCount || 0}
      isXml={Boolean(adDetails.summary.externalId)}
      onRefetch={refetchAdDetails}
    />
  ) : null;

  const isDetailChangeLayout = isDetailSwitch(width);

  const { header, description, imageId } = adDetails.sharingConfiguration;

  const canonical = adDetails.redirectData ? buildBaseUrl(
    "/" +
    adDetails.redirectData.module + "/" +
    adDetails.redirectData.category +
    PageRoute.details + "/" +
    adDetails.redirectData.smartLink + "/" +
    adDetails.redirectData.code
  ) : null;

  // if AgeVerification state is not calculated yet, we should not render the ads
  if (!ageVerificationModal && (!checkEmptyArray(categories) || !checkEmptyArray(modules))) {
    return null;
  }

  const pageTitle = `${header ? header : adDetails.summary.title} | ${"INDEX OGLASI"}`;
  const pageDesc = truncate(description ? description : adDetails.summary.description, 157);
  // FB-sized (1200x630) image for OG — small enough that WhatsApp/Viber
  // can fetch it within their timeout (the full-size original often is
  // not, which is why those scrapers were falling back to the site logo).
  // Discover still gets high-res images via the Product JSON-LD below.
  const ogImageName = imageId ? imageId : summary.images && summary.images[0];
  const pageOgImage = ogImageName ? getImageLink(ogImageName, "fb") : undefined;
  const adStructuredData = buildAdDetailStructuredData(adDetails, makes);

  // AgeVerification short-circuits the whole page for 18+ ads, but
  // Googlebot has no cookie so it would land on an empty document
  // without title/desc/canonical. Emit the Helmet first so crawlers
  // still see the metadata even when the modal takes over.
  if (shouldShowModal) {
    return (
      <React.Fragment>
        <HelmetComponent
          title={pageTitle}
          ogTitle={pageTitle}
          ogImage={pageOgImage}
          ogImageWidth={pageOgImage ? 1200 : undefined}
          ogImageHeight={pageOgImage ? 630 : undefined}
          desc={pageDesc}
          canonical={canonical}
          ogType="website"
          structuredData={adStructuredData}
        />
        <AgeVerification />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className={styles.wrapper}>
        <HelmetComponent
          title={pageTitle}
          ogTitle={pageTitle}
          ogImage={pageOgImage}
          ogImageWidth={pageOgImage ? 1200 : undefined}
          ogImageHeight={pageOgImage ? 630 : undefined}
          desc={pageDesc}
          canonical={canonical}
          ogType="website"
          structuredData={adStructuredData}
        />

        <div className={`child-center ${styles.topBar}`}>
          <BreadcrumbBar
            className={styles.breadcrumbBar}
            routeLinks={adDetails.routeLinks}
            category={props.adDetails.category}
            backDisabled={false}
          />
          <div className={styles.shareBar}>
            <span className={styles.barOptions}>
              <SharingOptions
                category={props.adDetails.category}
                categories={categories}
              />
            </span>
            <span className={styles.barOptions}>
              <PrintButton
                category={props.adDetails.category}
                categories={categories}
              />
            </span>
          </div>
        </div>
        {adDetails.summary.status === AdStatus.sold && (
          <div className={styles.content}>
            <div className={styles.notifications}>
              <div className={styles.sold}>
                <img
                  alt={"Ovaj oglas je prodan!"}
                  src={getIconUrl("notification-white.svg")}
                />
                <span className={styles.text}>
                  {"Ovaj oglas je prodan!"}
                </span>
              </div>
            </div>
          </div>
        )}
        {isOwnAd && adDetails.summary.status === AdStatus.active && !adDetails.summary.isPromoted && (
          <div className={`child-center ${styles.content}`}>
            <OwnAdBanner
              adId={adDetails.summary.id}
              title={adDetails.summary.title}
              imageName={summary.images && summary.images[0]}
            />
          </div>
        )}

        <div className={styles.content}>
          {/* summary section */}
          <div className={styles.summaryWrapper}>
            <SummarySection
              adSummary={adDetails.summary}
              adCreator={adDetails.creator}
              category={adDetails.category}
              hasContact={hasContact}
              onEdit={handleEditClick}
              onReportOpen={handleReportOpen}
              isReportVisible={isReportVisible}
              onReportSubmit={handleReportSubmit}
              onReportClose={handleReportClose}
              module={adDetails.module}
              showViewedCount={showViewedCount}
              isDetailChangeLayout={isDetailChangeLayout}
              specialAttributes={adDetails.specialAttributes}
            />
            {/* detail section */}
            <div className={styles.detailsSection}>
              <div className={styles.detailsLeft}>
                <SpecialSection
                  specialAttributes={adDetails.specialAttributes}
                  ad={{
                    id: adDetails.summary.id,
                    module: adDetails.module,
                    category: adDetails.category
                  }}
                  adSummary={adDetails.summary}
                  details={adDetails.details}
                />
                {forbiddAds ? null : (
                  <div style={{ margin: "0 auto", marginTop: 10 }}>
                    <GoogleAd
                      className={`child-center ${adsStyles.topAds} ${utilsStyles.MT5} ${utilsStyles.MB3}`}
                      config={{
                        ...googleAds.detailPage.top,
                        id: "googleAds.detailPage.top"
                      }}
                    />
                  </div>
                )}

                {
                  forbiddAds &&
                    adDetails.categoryLv1Id === "7ed638ad-724e-40c6-8760-d0e8e62428e4" && (
                      adDetails.categoryLv2Id === "1b8ec9f6-461d-4a03-ae25-272d20c87f74" ||
                      adDetails.categoryLv2Id === "329d4fdb-27dc-4cb1-9cf2-0870c342e36b"
                    ) ? (
                    <div className={styles.note}>
                      Prodaja isključivo uz predočenje važeće dozvole za posjedovanje oružja. Preuzimanje osobno.
                    </div>
                  ) : null
                }

                <section className={styles.adDetails}>
                  <DetailSection adDetails={adDetails.details}
                    specialAttributes={adDetails.specialAttributes}
                    category={adDetails.category}
                    adId={adDetails.summary.id}
                    hrPageName={hrPageName}
                    insertAfterSectionName="Osnovne informacije"
                    extraContent={
                      <MakeModelInfoCta
                        module={adDetails.module}
                        category={adDetails.category}
                        infoPage={adDetails.summary.infoPage}
                      />
                    } />
                </section>
                <PriceComparison adSummary={adDetails.summary} category={adDetails.category} module={adDetails.module} />
                {isDetailChangeLayout && (
                  <SellerSection
                    adCreator={adDetails.creator}
                    isReportVisible={isReportVisible}
                    onReportSubmit={handleReportSubmit}
                    onReportClose={handleReportClose}
                    onReportOpen={handleReportOpen}
                    adSummary={adDetails.summary}
                    handleContactClick={handleContactClick}
                    // @ts-ignore
                    category={adDetails.category}
                    module={adDetails.module}
                    hideContact={isOwnAd}
                    topSlot={ownAdPanel}
                  />
                )}
                {/* When the user scrolls to this span element then render and call similar ads */}
                <span ref={similarRef}></span>
              </div>

              {!forbiddAds && (
                <div style={{ margin: "0 auto", marginTop: 10 }}>
                  <GoogleAd
                    className={`${adsStyles.bottomAds} ${utilsStyles.MB5} ${utilsStyles.MT5}`}
                    config={{
                      ...googleAds.detailPage.bottom,
                      id: "googleAds.detailPage.bottom-1"
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          {/* Ad summary section */}
          {!isDetailChangeLayout && (
            <SellerSection
              adCreator={adDetails.creator}
              isReportVisible={isReportVisible}
              onReportSubmit={handleReportSubmit}
              onReportClose={handleReportClose}
              onReportOpen={handleReportOpen}
              adSummary={adDetails.summary}
              category={adDetails.category}
              handleContactClick={handleContactClick}
              user={user}
              module={adDetails.module}
              hideContact={isOwnAd}
              topSlot={ownAdPanel}
            />
          )}

        </div>
        <ActionBar
          adDetails={adDetails}
          hasPhones={summary && summary.hasPhones}
          isMobile={false}
          onChatClick={handleContactClick}
          user={user}
        />
        <div className={`child-center ${styles.bottomSection}`}>
          {loadingSimilar && <Loading />}
          {inView && (
            <SimilarAdsSection
              adId={summary.id}
              favoriteIds={favoriteIds}
              category={adDetails.category}
              setLoadingSimilar={e => setLoadingSimilar(e)}
            />
          )}
          <TipsSection className={forbiddAds ? utilsStyles.MB5 : ""} />
          {forbiddAds ? null : (
            <GoogleAd
              className={`${adsStyles.bottomAds} ${utilsStyles.MB5} ${utilsStyles.MT5}`}
              config={{
                ...googleAds.detailPage.bottom,
                id: "googleAds.detailPage.bottom-2"
              }}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

AdDetailsPageWeb.defaultProps = {
  adDetails: {},
  user: null,
  favoriteIds: [],
  match: {}
};

const ConnectedAdDetailsPage = connect(
  state => ({
    adDetails: selectAdDetails(state),
    user: selectLoadedUser(state),
    userRaw: selectUserInfo(state),
    favoriteIds: selectFavoriteIds(state),
    categories: selectCategories(state),
    modules: selectModules(state)
  }),
  {
    getAdDetails,
    updateViewCount,
    getCreatorInfo
  }
)(AdDetailsPageWeb);

export default submitFormData(
  getModuleContext(getWidthContext(ConnectedAdDetailsPage)),
  sendEmailToDealerAction
);



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/index.tsx